'use strict';

import Select from "./filter/Select";

export default function Sort({items = [], value = '', onChange}) {
    return <Select
        items={items}
        value={value}
        onChange={onChange}
        parentClass={"el-sorting__select"}
        selectClass={"el-sorting__selectbox"}
        dropdownClass={'el-sorting__drop'}
        required={true}
    />
}
